module.exports = __webpack_public_path__ + "img/red-stop-lamp-on.0ad158a8.svg";